var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',[_c('router-link',{staticClass:"btn dealers_btn ",attrs:{"to":{ name: 'bank-transaction-details'}}},[_vm._v("\n        "+_vm._s(_vm.$t('text.clickButtons.details'))+"\n       ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }